@if (title) {
  <div class="searchHeader">
    <div>&nbsp;</div>
    <h2 class="searchHeader__title">{{title}}</h2>
    <mat-icon class="searchHeader__closeIcon" (click)="onCloseClicked()">close</mat-icon>
  </div>
}

<div id="search-form">
  <form style="width:500px; display: block">
    <mat-form-field style="width:100%;">
      <input type="search" [ngModel]="searchTerm" [ngModelOptions]="{standalone: true}" matInput
        placeholder="{{placeholder}}" #quickSearch autofocus>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </form>
  </div>
  @if (!interns || isLoading) {
    <mat-progress-bar mode="indeterminate" aria-label="Loading"></mat-progress-bar>
  }
  <table mat-table [dataSource]="interns" #internTable>
    <ng-container matColumnDef="company">
      <th class="mat-header-company" mat-header-cell *matHeaderCellDef>Company</th>
      <td mat-cell *matCellDef="let intern">
        <span>{{ intern?.company?.code ?? "" }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="internNumber">
      <th mat-header-cell *matHeaderCellDef>Intern ID</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.internId); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef>Last Name</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.lastName); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef>First Name</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.firstName); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="emailAddress">
      <th mat-header-cell *matHeaderCellDef>Email Address</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.emailAddress); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="college">
      <th mat-header-cell *matHeaderCellDef>College</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.college); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="campus">
      <th mat-header-cell *matHeaderCellDef>Campus</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.campus); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="district">
      <th mat-header-cell *matHeaderCellDef>District</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.district); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.status); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef>City</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.city); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>State</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.state); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="dob">
      <th mat-header-cell *matHeaderCellDef>DOB</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.dob); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="ssn">
      <th mat-header-cell *matHeaderCellDef>SSN</th>
      <td mat-cell *matCellDef="let intern">
        @for (segment of getSegments(intern.ssn); track $index) {
          @if (segment.highlight) {
            <span class="highlight">{{ segment.text }}</span>
          }
          @if (!segment.highlight) {
            {{ segment.text }}
          }
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="intern-row" (click)="click(row)"></tr>
  </table>
  @if (!interns || !interns.length) {
    <div style="text-align: center; margin-top: 10px;">NO RECORDS TO DISPLAY</div>
  }